import React, { FC } from 'react';
import { Column } from 'features/document/documentSlice';
import ViewerElementSection from '../ViewerElementSection/ViewerElementSection';
import styles from './ViewerColumnSection.module.css';

interface ViewerColumnSectionProps {
  column: Column;
}

const ViewerColumnSection: FC<ViewerColumnSectionProps> = ({ column }) => {
  return (
    <div className={styles.container}>
      {column.elements.map(element => {
        return (
          <div className={styles.elementContainer} key={element.id}>
            <ViewerElementSection currentElement={element} />
          </div>
        );
      })}
    </div>
  );
};

export default ViewerColumnSection;
